module.exports = __webpack_public_path__ + "img/sharebg.d0828a44.png";